import React from "react";
import PropTypes from "prop-types";
import { AiFillBulb } from "react-icons/ai";
import IconWithBackground from "containers/chat/IconWithBackground/IconWithBackground";
import "./TextMessageContent.scss";
import MessageSuggestionService from "services/MessageSuggestionService";
import _colors from "styles/colors.module.scss";
const { lightOrange } = _colors;
import { connect } from "react-redux";
function TextMessageContent(props) {
  const { message, activeSuggestion } = props;
  const isCurrentMessageActiveSuggestion =
    activeSuggestion && activeSuggestion.messageId === message.messageId;
  const bulbColor = isCurrentMessageActiveSuggestion ? "#fff": lightOrange;
  const iconBgColor = isCurrentMessageActiveSuggestion ? lightOrange : "#fff";
  const boxShadowClass = !isCurrentMessageActiveSuggestion ? "icon-with-shadow" : "";
  const triggerSuggestionForMessage = () => {
    MessageSuggestionService.suggestMessagesFor(message);
  };
  return (
    <div className="text-message-content" data-testid="text-message-content">
      <div className="message-text">{message.message}</div>
      {message.suggestions && message.suggestions.length > 0 ? (
        <div className= {`suggestion ${boxShadowClass}`} onClick={triggerSuggestionForMessage}>
          <IconWithBackground
            icon={<AiFillBulb color={bulbColor} />}
            backgroundColor={iconBgColor}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

TextMessageContent.propTypes = {
  message: PropTypes.object,
};

const mapStateToProps = (state) => ({
  activeSuggestion: state.suggestion.activeSuggestion,
});

export default connect(mapStateToProps)(TextMessageContent);
